import { createFileRoute } from '@tanstack/react-router'
import { AssetDatabase } from 'pages/assetDatabase/AssetDatabase'
// TODO: ARCH-529
// eslint-disable-next-line boundaries/element-types
import { assetDBSearchSchema } from 'types'

export const Route = createFileRoute('/assets/{-$siteID}/')({
  component: RouteComponent,
  staticData: {
    title: 'Assets',
  },
  validateSearch: assetDBSearchSchema,
})

function RouteComponent() {
  return (
    <>
      <AssetDatabase />
    </>
  )
}
